export const TMMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M6 10h38l-7 8H27v38l-11-8V18H6z" fill="#D7191C" />
    <path d="M30 26l10 8 10-8v30l8 5V14L40 27l-10-8z" fill="#F8FAFC" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <TMMark className="w-10 h-10 shrink-0" />
    {!compact && (
      <span className="leading-none">
        <span className="block text-[9px] tracking-[0.45em] text-slate-300 font-sans">THE</span>
        <span className="block font-sans font-extrabold text-[15px] tracking-tight text-white">
          TRANSFORMED <span className="text-brandred">MIND</span> <span className="font-light tracking-[0.2em] text-[12px]">LIFE</span>
        </span>
        <span className="block text-[8px] tracking-[0.35em] text-gold-light mt-1">WITH TODD COCONATO</span>
      </span>
    )}
  </span>
);
